// Live sidebar, settings, POS cards, and actions used by the role editor.

export const SIDEBAR_CATALOG = [
  { key: "pos", label: "POS" },
  { key: "kds", label: "KDS" },
  { key: "layout", label: "Layout" },
  { key: "reservations", label: "Reservations" },
  { key: "customers", label: "Customers" },
  { key: "menus", label: "Menus" },
  { key: "analytics", label: "Analytics" },
  { key: "settings", label: "Settings" },
  { key: "mev", label: "Printers and Cloud MEV" },
  { key: "store", label: "Store" },
] as const;

export const SETTINGS_TAB_CATALOG = [
  { key: "storeDetails", label: "Store Details" },
  { key: "storeOperation", label: "Store Operation" },
  { key: "menu", label: "Menu" },
  { key: "order", label: "Order" },
  { key: "payment", label: "Payment" },
  { key: "print", label: "Print" },
  { key: "webhooks", label: "Webhooks" },
  { key: "users", label: "Users" },
  { key: "others", label: "Data Management" },
  { key: "tables", label: "Tables" },
  { key: "website", label: "Online ordering" },
  { key: "cloudSync", label: "Cloud Sync" },
] as const;

export const SETTINGS_CARD_CATALOG: Record<string, { key: string; label: string }[]> = {
  storeDetails: [
    { key: "storeInformation", label: "Store Information" },
    { key: "storeLogo", label: "Store Logo" },
    { key: "storeHours", label: "Store Hours" },
    { key: "specialHours", label: "Special Hours" },
  ],
  storeOperation: [
    { key: "storeType", label: "Store Type" },
    { key: "serviceMode", label: "Service Mode" },
    { key: "sessionDisplay", label: "Session and Display" },
    { key: "keypadPopupAtLogin", label: "Keypad popup at login" },
    { key: "dashboardCards", label: "POS Dashboard Cards" },
    { key: "tableView", label: "Default Table View" },
    { key: "eodSettings", label: "End of Day" },
    { key: "trainingMode", label: "Training Mode" },
    { key: "regionalIntegration", label: "Regional and Integration" },
  ],
  menu: [
    { key: "categories", label: "Categories" },
    { key: "menuManagement", label: "Menu Management" },
    { key: "pricingFees", label: "Pricing and Fees" },
    { key: "ruleManagement", label: "Rule Management" },
  ],
  order: [
    { key: "orderRules", label: "Order Rules" },
    { key: "pricingRounding", label: "Pricing and Rounding" },
    { key: "orderPreferences", label: "Order Preferences" },
  ],
  payment: [{ key: "paymentSettings", label: "Payment Settings" }],
  print: [
    { key: "corePrintSettings", label: "QR Code Print Setting" },
    { key: "additionalSettings", label: "Additional QR Setting" },
    { key: "printersList", label: "Printers List" },
  ],
  webhooks: [{ key: "webhooksIntegration", label: "Webhooks Integration" }],
  users: [{ key: "userManagement", label: "User Management" }],
  others: [
    { key: "dataManagement", label: "Data Management" },
    { key: "exportData", label: "Export Data" },
  ],
  tables: [{ key: "tableManagement", label: "Table Management" }],
  website: [],
  cloudSync: [{ key: "cloudStorageOperations", label: "Cloud Storage Operations" }],
};

export const POS_CARD_CATALOG = [
  { key: "categories", label: "Categories" },
  { key: "products", label: "Products" },
  { key: "savedCart", label: "Tickets in progress" },
  { key: "tables", label: "Tables" },
  { key: "orders", label: "Orders" },
  { key: "takeaway", label: "Takeaway" },
  { key: "delivery", label: "Delivery" },
  { key: "delivery_local", label: "Delivery (Local)" },
  { key: "kiosk", label: "Kiosk" },
  { key: "reservations", label: "Reservations" },
  { key: "online", label: "Online Orders" },
  { key: "transactions", label: "Transactions" },
  { key: "customers", label: "Customers" },
  { key: "thirdParty", label: "Third Party" },
  { key: "settings", label: "Settings" },
  { key: "timeClock", label: "Clock in / clock out" },
] as const;

export const ACTION_CATALOG = [
  { key: "createOrders", label: "Create orders" },
  { key: "editOpenOrders", label: "Edit open orders" },
  { key: "accessOthersOrders", label: "Access other employees' orders" },
  { key: "acceptPayments", label: "Accept payments" },
  { key: "cancelUnpaidOrders", label: "Cancel unpaid orders" },
  { key: "refundPayments", label: "Refund payments", limit: true },
  { key: "applyDiscounts", label: "Apply discounts", limit: true },
  { key: "openCashDrawer", label: "Open cash drawer" },
  { key: "closeShift", label: "Close shift" },
  { key: "endOfDay", label: "End of day" },
  { key: "viewOwnSales", label: "View own sales" },
  { key: "viewAllSales", label: "View all sales" },
  { key: "manageEmployees", label: "Manage employees" },
  { key: "changeMenuPrices", label: "Change menu prices" },
  { key: "manageRestaurantSettings", label: "Restaurant settings" },
  { key: "viewKitchenOrders", label: "View kitchen orders" },
  { key: "updateKitchenStatus", label: "Update kitchen status" },
  { key: "clockInOut", label: "Clock in / clock out" },
  { key: "viewLabourReport", label: "View labour report" },
  { key: "editAttendance", label: "Edit attendance" },
  { key: "forceClockOut", label: "Force clock-out" },
  { key: "endOtherShift", label: "End another employee's shift" },
  { key: "openDrawerSession", label: "Open cash drawer session" },
  { key: "cashIn", label: "Cash in" },
  { key: "cashOut", label: "Cash out" },
  { key: "cashDrop", label: "Cash drop" },
  { key: "countCash", label: "Count cash" },
  { key: "closeDrawerSession", label: "Close cash drawer" },
  { key: "approveCashVariance", label: "Approve cash variance" },
  { key: "handoverDrawer", label: "Handover cash drawer" },
  { key: "viewDrawerReports", label: "View cash drawer reports" },
] as const;

export const POS_CARD_ROUTES: { prefix: string; card: string }[] = [
  { prefix: "/admin/pos/clock", card: "timeClock" },
  { prefix: "/admin/pos/categories", card: "categories" },
  { prefix: "/admin/pos/orders", card: "orders" },
  { prefix: "/admin/pos/transactions", card: "transactions" },
  { prefix: "/admin/pos/customers", card: "customers" },
  { prefix: "/admin/pos/reservations", card: "reservations" },
  { prefix: "/admin/pos/parked-tickets", card: "savedCart" },
  { prefix: "/admin/pos/tables", card: "tables" },
  { prefix: "/admin/pos/online", card: "online" },
  { prefix: "/admin/pos/kiosk", card: "kiosk" },
  { prefix: "/admin/pos/third-party", card: "thirdParty" },
  { prefix: "/admin/pos/delivery-local", card: "delivery_local" },
];
